<template>
    <div class="resumeOther">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>工作经历</h1>
            </el-col>
            <el-col :span="20">
                <el-row v-for="item in resumeInfo.workExperienceList" :key="item.id">
                    <el-col :span="12"><b>{{item.positionName}}</b></el-col>
                    <el-col :span="12">
                        <span>在职时间：</span>{{item.joinTime}} ~ {{item.outTime}}
                    </el-col>
                    <el-col :span="12">
                        <span>所属行业：</span><span v-text="industryFormatter(item)"></span>
                    </el-col>
                    <el-col :span="12">
                        <span>公司名称：</span>{{item.company}}
                    </el-col>
                    <!--<el-col :span="12">-->
                    <!--<span>工作性质：</span>-->
                    <!--</el-col>-->
                    <el-col :span="24">
                        <span>工作描述：</span>{{item.description}}
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default {
        name: 'workExperience',
        props: ['resumeInfo'],
        methods: {
            industryFormatter(item) {
                if (!item) {
                    return '';
                }
                return item.industry.join("/");
            }
        }
    };
</script>